<template>
  <div>
    <v-col cols="12">
      <v-card-title class="headline orange text-white">
        <v-icon color="white mdi-24px">mdi-package-variant-closed</v-icon>
        <v-divider class="mx-4" vertical></v-divider>
        Datos del Proveedor
      </v-card-title>
      <v-card class="pa-2" elevation="0" color="brown lighten-5" outlined>
        <v-card-text>
          <!-- <strong class="cliente">Datos del Proveedor</strong> -->
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                v-model="editedItem.idestablecimiento"
                :items="getEstablecimientosActivas"
                item-text="nombrecomercial"
                item-value="idestablecimiento"
                outlined
                dense
                @change="setIdEstablecimiento"
                label="Seleccione Establecimiento"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8">
              <v-autocomplete :items="getAllClientes" v-model="proveedor.nit" dense color="blue" outlined
                    clearable hide-details hide-selected :item-text="getItemText" item-value="nit"
                    @change="setDatos()" label="Seleccione Proveedor">
                    <template v-slot:no-data>
                        
                        <v-list-item>
                            <v-list-item-title>
                                <strong>No se contro ningun registro </strong>

                                <v-spacer></v-spacer>
                                <v-btn small dark color="blue" @click="$router.push({name:'CrearEditarPersona'})">
                                    <v-icon>mdi-account-plus</v-icon>
                                    Crear
                                </v-btn>

                            </v-list-item-title>
                        </v-list-item>
                    </template>
              </v-autocomplete>
             
              <v-text-field
                dense
                v-model="proveedor.nombre"
                label="Nombre Proveedor"
                class="mt-5"
              ></v-text-field>
              <v-text-field
                dense
                v-model="proveedor.direccion"
                label="Dirección"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-select
                dense
                v-model="editedItem.documento"
                :items="tipodocumentos"
                label="Tipo documento"
              ></v-select>
              <v-text-field
                dense
                v-model="editedItem.serie"
                label="Serie"
              ></v-text-field>
              <v-text-field
                dense
                v-model="editedItem.numero"
                label="Número Factura"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-btn
                class="text-white"
                color="red"
                style="text-decoration: none"
                @click="createCliente"
                v-if="!proveedorEncontrado"
              >
                REGISTRAR PROVEEDOR
              </v-btn>
            </v-col>

          
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name:"DatosProveedor",
  data() {
    return {
      proveedorEncontrado: true,
      tipodocumentos: [
        "Factura Electronica",
        "Factura",
        "Factura Cambiaria",
        "Recibo",
        "Otro",
      ],
      proveedor: {
        nombre: "CONSUMIDOR FINAL",
        nit: "CF",
        direccion: "JALAPA",
      },
      editedItem: {
        idpersona: 1,
        idusuario: 1,
        cliente: "CONSUMIDOR FINAL",
        numero: 1,
        idestablecimiento: 1,
        serie: "",
        descuento: 0,
        total: 0,
        tipo: "Compra",
        documento: "Factura Electronica",
      },
      defaultItem: {
        idpersona: 1,
        idusuario: 1,
        cliente: "CONSUMIDOR FINAL",
        numero: 1,
        idestablecimiento: 0,
        serie: "",
        descuento: 0,
        total: 0,
        tipo: "Compra",
        documento: "Factura Electronica",
      },
    };
  },
  // async created() {
  // this.editedItem.idestablecimiento = parseInt(
  //     localStorage.getItem("idestablecimiento")
  //   ) ;
  // },
  computed: {
     ...mapGetters(['getEstablecimientosActivas','getAllClientes',"getClientes"]),
  },
  methods: {
    getItemText(item) {
            return `${item.nit} - ${item.nombre}`;
        },
    setDatos() {
          
            const {nombre,direccion,idpersona} = this.getClientes(
                                            this.proveedor.nit.toUpperCase()
                                        );

                                        
            this.proveedor.idpersona = idpersona               
            this.proveedor.nombre = nombre               
            this.proveedor.direccion = direccion    
            this.editedItem.idpersona = idpersona;
            this.editedItem.cliente = nombre;

            this.$emit('datoscomprobante',this.editedItem)
    },
    setIdEstablecimiento() {
        localStorage.setItem(
          "idestablecimiento",
          this.editedItem.idestablecimiento
        );
     },
    
    async createCliente() {
      await this.$store.dispatch("createCliente", this.proveedor);
      //Recargamos el inicio para obtener los clientes
      await this.initialize();
      // //Buscamos nuevamente el cliente invocando al metodo buscarProveedor
      // await this.buscarProveedor();
    },
  },
};
</script>
